import { render, staticRenderFns } from "./UISelectWithParse.vue?vue&type=template&id=8f890d88&"
import script from "./UISelectWithParse.vue?vue&type=script&lang=js&"
export * from "./UISelectWithParse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports